import { Component, Input, OnInit } from '@angular/core';

export enum InstructionsSteps {
  PACK = 'pack',
  PRINT = 'print',
  GREET = 'greet',
}

interface InstructionsStep {
  index: number;
  title: string;
  description: string;
}

const instructionsStepsProperties: { [stepType: string]: InstructionsStep } = {
  [InstructionsSteps.PACK]: {
    index: 1,
    title: 'PACK',
    description: 'Pack your order safely. A sealed bag is fine.',
  },
  [InstructionsSteps.PRINT]: {
    index: 2,
    title: 'PRINT',
    description: ' and stick it on your package.',
  },
  [InstructionsSteps.GREET]: {
    index: 3,
    title: 'DROP OFF',
    description: 'Drop off the packages in a collection point.',
  },
};

@Component({
  selector: 'common-instructions-step',
  templateUrl: './instructions-step.component.html',
  styleUrls: ['./instructions-step.component.scss'],
})
export class InstructionsStepComponent implements OnInit {
  protected readonly InstructionsSteps = InstructionsSteps;
  @Input() brandColor!: string;
  @Input() deliveryPartner?: string;
  @Input() step!: InstructionsSteps;
  @Input() lastStep?: boolean;
  @Input() labelUrl?: string;

  stepProperties?: InstructionsStep;

  ngOnInit(): void {
    this.stepProperties = instructionsStepsProperties[this.step];
    if (this.step === InstructionsSteps.GREET && this.deliveryPartner) {
      this.stepProperties.description = `Drop off the packages in a ${this.deliveryPartner} collection point.`;
    }
  }
}
